[
  {
    "Name": "Kathmandu",
    "Nepali": "काठमाण्डौ",
    "District": "Kathmandu",
    "Province": "Province No. 3",
    "Population_2011": "975,453",
    "Area_km2": "49.45"
  },
  {
    "Name": "Pokhara",
    "Nepali": "पोखरा",
    "District": "Kaski",
    "Province": "Gandaki",
    "Population_2011": "426,759",
    "Area_km2": "464.28"
  },
  {
    "Name": "Lalitpur",
    "Nepali": "ललितपुर",
    "District": "Lalitpur",
    "Province": "Province No. 3",
    "Population_2011": "284,922",
    "Area_km2": "36.12"
  },
  {
    "Name": "Bharatpur",
    "Nepali": "भरतपुर",
    "District": "Chitwan",
    "Province": "Province No. 3",
    "Population_2011": "280,502",
    "Area_km2": "432.95"
  },
  {
    "Name": "Birgunj",
    "Nepali": "बिरगंज",
    "District": "Parsa",
    "Province": "Province No. 2",
    "Population_2011": "240,922",
    "Area_km2": "132.07"
  },
  {
    "Name": "Biratnagar",
    "Nepali": "विराटनगर",
    "District": "Morang",
    "Province": "Province No. 1",
    "Population_2011": "214,663",
    "Area_km2": "77.00"
  }
]